import { Box, Container } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { deleteSlider, showSlider } from '../../../../../redux/actions/sliders'
import { IRootState } from '../../../../../redux/types'
import Header from '../../../../shared/components/Header'
import NotFilter from '../../../../shared/components/NotFilter'
import SubHeader from '../../../../shared/styles/Subheader'
import { SliderHeaderFilters } from '../components/SliderHeaderFilters'
import { SlidersDialog } from '../components/SlidersDialog'
import { SlidersFilters } from '../components/SlidersFilters'
import SlidersNotifications from '../components/SlidersNotifications'
import SliderModal from '../components/forms/SliderModal'
import { SlidersTable } from '../components/table/SlidersTable'
import useFiltersState from '../hooks/useFiltersState'
import { useState } from 'react'

function Sliders() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { sliders, showForm, loading } = useSelector((state: IRootState) => state.slider)
  const { handleChangeFilter, handleClickSetOptions, filters, optionsData } = useFiltersState()
  const [openDeleteSlider, setOpenDeleteSlider] = useState(false)
  const [sliderSelected, setSliderSelected] = useState<number | null>(null)

  return (
    <>
      <Header title="Slider" />
      <SubHeader>
        <SliderHeaderFilters filters={filters} handleChangeFilter={handleChangeFilter} />
      </SubHeader>

      <Container maxWidth="lg" id="sliders-admin-container">
        <SlidersFilters filters={filters} optionsData={optionsData} handleClickSetOptions={handleClickSetOptions} />
        {sliders.length === 0 && !loading ? (
          <NotFilter subsection={null} handleClearFilters={handleClickSetOptions} />
        ) : (
          <Box mt={3}>
            <div className="tableclass.table">
              <SlidersTable
                sliders={sliders}
                loading={loading}
                onView={(id: number) => navigate(`${id}`)}
                onEdit={(id: number) => dispatch(showSlider(id))}
                onDelete={(id: number) => {
                  setOpenDeleteSlider(!openDeleteSlider)
                  setSliderSelected(id)
                }}
              />
            </div>
          </Box>
        )}
        {showForm && <SliderModal type={filters.internaltype} position={filters.position} title={filters.modal_title} />}
        <SlidersDialog
          openDeleteSlider={openDeleteSlider}
          setOpenDeleteSlider={setOpenDeleteSlider}
          onDelete={() => {
            dispatch(deleteSlider(sliderSelected))
            setOpenDeleteSlider(!openDeleteSlider)
          }}
        />
        <SlidersNotifications />
      </Container>
    </>
  )
}

export default Sliders
